import { weekBody } from "./weekBody";
export function weekUI() {
    return `
      <div class="bible-reading__week">
        ${weekBody()}
      </div>
    `;
}
